import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';
import * as providersEnvironment from '#shared/util/providersEnvironment.js';

import { setCookiePublic, isDeveloperRequest } from '#backend/util/request.js';

/**
 * Set env cookie in case of development mode so frontend is aligned with backend
 */
export default defineThemeMiddleware(({ env, route, request }) => {
	const isDeveloper = isDeveloperRequest(request, () => route.query.developer === '1');
	const isTest = isDeveloper && route.query.testOrder === '1';
	if (isDeveloper) {
		const developerEnv = isDeveloper ? route.query.env : '';
		const testOrderEnv = isTest ? route.query.env || providersEnvironment.createString(route.query.provider, env) : '';
		setCookiePublic(request, 'env', testOrderEnv || developerEnv || env.providersEnvironment);
	}
}, (context) => context.isServerProcess && context.route.query.clearCart === '1');
